export default __webpack_public_path__ + "static/media/info-icon-light.c688916d.svg";